import { IconComponentProps } from '../IconTypes';

const WarehouseExclamationSolid = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.1986 11.7997C10.5231 11.7998 10.8289 11.8783 11.0998 12.0155C10.4491 12.3455 10.0024 13.0201 10.0024 13.7998V19.5998C10.0024 20.3793 10.4494 21.0531 11.0998 21.3831C10.8288 21.5205 10.5233 21.5998 10.1986 21.5999H4.39916C3.29498 21.5997 2.39961 20.7043 2.39961 19.5998V13.7998C2.39961 12.6953 3.29498 11.7999 4.39916 11.7997H6.09898V14.2002C6.09919 14.5314 6.36826 14.7998 6.69943 14.7998H7.89838C8.22955 14.7998 8.49862 14.5314 8.49883 14.2002V11.7997H10.1986Z"
      fill="currentColor"
    />
    <path
      d="M14.9015 2.3999C16.0058 2.4 16.9011 3.29543 16.9011 4.39998V10.6004H7.10345V4.39998C7.10345 3.29537 7.99868 2.3999 9.103 2.3999H10.8018V4.80039C10.8021 5.1316 11.0711 5.40002 11.4023 5.40002H12.6022C12.9332 5.3998 13.2015 5.13146 13.2017 4.80039V2.3999H14.9015Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M19.6008 11.7997C20.7051 11.7998 21.6004 12.6952 21.6004 13.7998V19.5998C21.6004 20.7044 20.7051 21.5998 19.6008 21.5999H13.8023C12.698 21.5999 11.8028 20.7044 11.8028 19.5998V13.7998C11.8028 12.6952 12.698 11.7997 13.8023 11.7997H19.6008ZM16.7011 18.4006C16.2595 18.4007 15.9016 18.7587 15.9015 19.2004C15.9015 19.6422 16.2595 20.0001 16.7011 20.0002C17.1428 20.0002 17.5007 19.6422 17.5007 19.2004C17.5006 18.7586 17.1428 18.4006 16.7011 18.4006ZM16.7011 13.4004C16.37 13.4005 16.1018 13.6688 16.1016 14V17.0001C16.1016 17.3314 16.3699 17.6006 16.7011 17.6007C17.0324 17.6007 17.3015 17.3315 17.3015 17.0001V14C17.3013 13.6688 17.0323 13.4004 16.7011 13.4004Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default WarehouseExclamationSolid;
